// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__LHic5"};